export const address: object = {
  addressForm: {
    title: 'Title',
    firstName: {
      label: 'Vorname',
      placeholder: 'Vorname',
    },
    lastName: {
      label: 'Nachname',
      placeholder: 'Nachname',
    },
    address1: 'Addresse 1',
    address2: 'Addresse 2 (optional)',
    country: 'Land',
    city: {
      label: 'Stadt',
      placeholder: 'Stadt',
    },
    state: 'Staat',
    zipCode: {
      label: 'Postleitzahl',
      placeholder: 'Postleitzahl',
    },
    phoneNumber: {
      label: 'Telefonnummer (optional)',
      placeholder: '(555) 555 - 0123',
    },
    saveAsDefault: 'Als Standard speichern',
    chooseAddress: 'Adresse auswählen',
    streetAddress: 'Straße',
    streetAddressTooltip: 'Die Eingabe einer Straßenadresse hilft uns, Ihr Unternehmen besser zu identifizieren',
    aptSuite: 'Apt, Suite',
    selectOne: 'Wählen Sie eine...',
    setAsDefault: 'Als Standard festlegen',
    titleRequired: 'Als Standard festlegen.',
    userAddressAddSuccess: 'Neue Adresse wurde erfolgreich hinzugefügt!',
    userAddressUpdateSuccess: 'Adresse erfolgreich aktualisiert!',
    userAddressDeleteSuccess: 'Adresse erfolgreich gelöscht!',
    invalidAddress: 'Ungültige Adresse',
  },
  addressBook: {
    addNewShippingAddress: 'Fügen Sie eine neue Lieferadresse hinzu',
    editShippingAddress: 'Lieferadresse bearbeiten',
    areYouSureToDeleteAddress: 'Sind Sie sicher, dass Sie diese Adresse löschen wollen?',
    addNewAddress: 'Neue Adresse hinzufügen',
    addAddress: 'Adresse hinzufügen',
    updateAddress: 'Adresse aktualisieren',
    backToAddressList: 'Zurück zur Adressliste',
  },
  addressCard: {
    default: 'STANDARD',
    selected: 'Ausgewählt',
    setAsDefault: 'Als Standard festlegen',
    shipTo: 'Versand an',
    billTo: 'Rechnung an',
  },
};
